module.exports = __webpack_public_path__ + "img/zh_bg.541ad6c3.png";